/** How often the countdown redraws. */
export const TICK_MS = 1000;

/** In the last minute the bar turns red and the status line changes. */
export const LAST_MINUTE_MS = 60_000;

/** mm:ss for a span in milliseconds, rounded up so the last second still shows. */
export function formatCountdown(ms: number): string {
  const totalSeconds = Math.ceil(Math.max(0, ms) / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

/** Share of the code's life still left, from 0 to 1, for the draining bar. */
export function remainingFraction(remainingMs: number, windowMs: number): number {
  if (windowMs <= 0) return 0;
  return Math.min(1, Math.max(0, remainingMs / windowMs));
}

/** The code with an en dash between its halves, as printed: KQ7–M4PR. */
export function linkCodeDisplay(code: string): string {
  const [first, second] = code.split("-");
  return first && second ? `${first}–${second}` : code;
}
